import {unchanging} from '@packages/utilities/component';
import {styledDiv, styled, tokens} from '@packages/utilities/styled';
import {Icon as SpringIcon} from '@packages/systems/spring';
import {shadow} from '@packages/utilities/inline-style-utils';
import {Card} from './Card';
import {Clickable} from './logic/clickable';
import {getOptionVerticalPadding} from './logic/dropdown';

// `divided` is optional — call sites such as `Menu.Wrapper` elsewhere in the
// codebase render the wrapper without passing it.
const wrapperStyle = ({
  theme: {dropdown},
  divided,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme: {dropdown: any};
  divided?: boolean;
}) => ({
  boxShadow: divided
    ? shadow(0, -1 * dropdown.dividerWidth, 0, dropdown.dividerColor)
    : undefined,
  height: divided ? 1 : undefined,
});

// @ts-expect-error - TS7031 - Binding element 'gutters' implicitly has an 'any' type. | TS7031 - Binding element 'control' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
const dividerStyle = ({theme: {gutters, control}, style}) => ({
  height: control.borderWidth,
  marginTop: gutters.x8 / 2,
  marginBottom: gutters.x8 / 2,
  background: tokens.colors.border1,
  pointerEvents: 'none',
  ...style,
});

// @ts-expect-error - TS7031 - Binding element 'control' implicitly has an 'any' type. | TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
const groupDividerStyle = ({theme: {control, colors}, style}) => ({
  position: 'relative',
  top: -1,
  height: control.borderWidth,
  background: colors.border,
  pointerEvents: 'none',
  ...style,
});

// @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'dropdown' implicitly has an 'any' type. | TS7031 - Binding element 'Select' implicitly has an 'any' type.
const panelStyle = ({theme: {colors, dropdown, Select}}) => ({
  position: 'absolute',
  overflow: 'hidden',
  borderWidth: Select.controlBorderWidth,
  borderStyle: 'solid',
  borderColor: colors.border,
  backgroundColor: dropdown.backgroundColor,
});

// @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
const itemStyle = ({theme, style}) => {
  const verticalPadding = getOptionVerticalPadding(theme);
  const horizontalPadding = theme.dropdown.horizontalPadding;

  const result = {
    [SpringIcon.__experimentalTokens.color]: tokens.colors.textSecondary,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
  } as const;
  return style ? {...result, ...style} : result;
};

const itemVariants = {
  // @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'Select' implicitly has an 'any' type. | TS7031 - Binding element 'noHover' implicitly has an 'any' type.
  hover: ({theme: {colors, Select}, noHover}) => ({
    [SpringIcon.__experimentalTokens.color]: tokens.colors.textPrimary,
    color: !noHover ? colors.foregroundVivid : undefined,
    background: !noHover ? Select.itemBackgroundColorHover : undefined,
  }),
  // @ts-expect-error - TS7031 - Binding element 'colors' implicitly has an 'any' type. | TS7031 - Binding element 'hover' implicitly has an 'any' type. | TS7031 - Binding element 'disabledHover' implicitly has an 'any' type. | TS7031 - Binding element 'isNoteItem' implicitly has an 'any' type.
  disabled: ({theme: {colors}, hover, disabledHover, isNoteItem}) => ({
    color: colors.foregroundDimmer,
    background: disabledHover && hover ? colors.control : undefined,
    pointerEvents: disabledHover ? undefined : 'none',
    cursor: disabledHover ? 'not-allowed' : undefined,
    opacity: isNoteItem ? 1 : 0.6,
    boxShadow: isNoteItem ? 'none' : undefined,
  }),
  // @ts-expect-error - TS7031 - Binding element 'fontWeights' implicitly has an 'any' type. | TS7031 - Binding element 'dropdown' implicitly has an 'any' type.
  header: ({theme: {fontWeights, dropdown}}) => ({
    color: dropdown.colorHeader,
    background: dropdown.backgroundHeader,
    pointerEvents: 'none',
    fontWeight: fontWeights.subheading,
  }),
} as const;

/**
 * @deprecated use `MenuItem` from `@packages/systems/spring` instead
 */
export const Item = styled(Clickable)(itemStyle, itemVariants);

/**
 * @deprecated use `MenuDivider` from `@packages/systems/spring` instead
 */
export const Divider = unchanging(styledDiv(dividerStyle));

/**
 * @deprecated use `MenuDivider` from `@packages/systems/spring` instead
 */
export const GroupDivider = unchanging(styledDiv(groupDividerStyle));

/**
 * @deprecated use `Menu` from `@packages/systems/spring` instead
 */
export const Wrapper = styledDiv(wrapperStyle);

/**
 * @deprecated use `MenuContent` from `@packages/systems/spring` instead
 */
export const Panel = styled(Card)(panelStyle);
